import { render, staticRenderFns } from "./previewFyInfo.vue?vue&type=template&id=6bb4d9d7&"
import script from "./previewFyInfo.vue?vue&type=script&lang=js&"
export * from "./previewFyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports